export default __webpack_public_path__ + "static/media/clock-box_transparent.fb19e1f0.png";